import type { IncidentDetail } from "@/api/types";

interface Props {
  incident: IncidentDetail;
}

export function IncidentContext({ incident }: Props) {
  return (
    <div className="space-y-3 rounded-lg border bg-card p-4">
      <div>
        <div className="text-xs uppercase tracking-wider text-muted-foreground">
          Incidente
        </div>
        <div className="mt-1 font-mono text-xs text-muted-foreground">
          {incident.incident_id}
        </div>
        <div className="mt-1 text-sm font-medium">{incident.summary}</div>
      </div>
      <div className="grid grid-cols-2 gap-2 text-xs">
        <div>
          <div className="text-muted-foreground">Prioridad</div>
          <div className="font-mono">{incident.priority}</div>
        </div>
        <div>
          <div className="text-muted-foreground">Estado</div>
          <div className="font-mono">{incident.status}</div>
        </div>
        <div>
          <div className="text-muted-foreground">Eventos</div>
          <div className="font-mono">{incident.event_count}</div>
        </div>
        <div>
          <div className="text-muted-foreground">Severidades</div>
          <div className="font-mono">
            {incident.raw_severities.join(", ") || "—"}
          </div>
        </div>
      </div>
      {incident.affected_hosts.length > 0 && (
        <div>
          <div className="text-xs text-muted-foreground">Hosts afectados</div>
          <div className="text-sm">{incident.affected_hosts.join(", ")}</div>
        </div>
      )}
      {incident.trigger_descriptions.length > 0 && (
        <div>
          <div className="text-xs text-muted-foreground">Disparadores</div>
          <ul className="mt-1 list-disc pl-4 text-sm">
            {incident.trigger_descriptions.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        </div>
      )}
      {incident.metric_names.length > 0 && (
        <div>
          <div className="text-xs text-muted-foreground">Métricas</div>
          <div className="font-mono text-sm">
            {incident.metric_names.join(", ")}
          </div>
        </div>
      )}
    </div>
  );
}
